import React, { useEffect, useState } from "react"
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
} from "@mui/material"
import {
  AiFillLock,
  AiFillUnlock,
  AiOutlineMail,
  AiOutlineUser,
} from "react-icons/ai"
import mommylogo from "../../images/login-logo.png"
import baby1 from "../../images/baby1.png"
import baby3 from "../../images/babby3.png"
import baby2 from "../../images/baby3.png"
import baby4 from "../../images/babby4.png"
import googleLogo from "../../images/google-logo.png"
import * as yup from "yup"
import { Controller, useForm } from "react-hook-form"
import {
  useSignupWithGoogleMutation,
  useUserRegisterMutation,
} from "../../features/Auth/authApi"
import { useNavigate } from "react-router-dom"
import { yupResolver } from "@hookform/resolvers/yup"
import CircularProgress from "@mui/material/CircularProgress"
import { useAppSelector } from "../../app/hooks"
import { MdLocalPhone } from "react-icons/md"
import { toast } from "react-toastify"
import { MdVisibility, MdVisibilityOff } from "react-icons/md"
import { logout } from "../../features/Auth/authSlice"
import { useAppDispatch } from "../../app/store"
import { commonTerms } from "../Booking-Form/termsConfig"
interface SignUpUser {
  name: string
  email: string
  password: string
  contactNo: string
}
const Signup = () => {
  const [handleGoogleLogin, { isLoading: googleLoading }] =
    useSignupWithGoogleMutation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)
  const [userRegister, { isError, error, data }] = useUserRegisterMutation()
  const token = useAppSelector((state) => state.auth.token)

  // Terms and Conditions State
  const [showTermsModal, setShowTermsModal] = useState(false)
  const [termsAccepted, setTermsAccepted] = useState(false)

  const handleClickShowPassword = () => setShowPassword((show) => !show)
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault()
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const schemaResolver = yupResolver(
    yup.object().shape({
      name: yup
        .string()
        .required("Please enter name")
        .transform((value) => value.trim()) // Remove spaces
        .matches(/^[a-zA-Z\s]*$/, "Name should only contain letters and spaces")
        .min(3, "Name should be of 3-25 characters only")
        .max(25, "Name should be of 3-25 characters only"),
      email: yup
        .string()
        .required("Please enter an email")
        .test("valid-email", "Please enter a valid email", (value) =>
          emailRegex.test(value),
        ),

      contactNo: yup
        .string()
        .required("Please enter phone number")
        .matches(/^(1\s?)?[2-9]\d{2}[2-9]\d{6}$/, "Please enter a valid Canadian phone number (e.g. 604XXXXXXX)")
        .test(
          "not-all-zeros",
          "Phone number cannot be all zeros",
          (value) => value !== undefined && !/^0+$/.test(value),
        ),
      password: yup
        .string()
        .required("Please fill in a password")
        .test(
          "password-length",
          "Password must be 8 characters or more",
          (value: any) => value && (value as any).length >= 8,
        )
        .test(
          "password-strength",
          "Include at least one uppercase letter, one lowercase letter, one number, and one special character",
          (value) =>
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&~^])[A-Za-z\d@$!%*#?&~^]{8,}$/.test(
              value || "",
            ),
        ),
    }),
  )

  const {
    control,
    handleSubmit,
    formState: { errors },
    trigger,
  } = useForm<SignUpUser, any>({
    resolver: schemaResolver,
  })
  const onSubmit = (values: any) => {
    if (!termsAccepted) {
      toast.error("Please accept the Terms and Conditions to proceed");
      return;
    }
    const payload = {
      name: values.name.trim(),
      contactNo: values.contactNo,
      email: values.email,
      password: values.password,
    }

    userRegister(payload)
    setLoading(true)
  }
  useEffect(() => {
    if (isError || error) {
      setLoading(false)
      toast.error(
        (error as any)?.data?.message || "Something went wrong. Please try again.",
        { autoClose: 2000 },
      )
      return
    }
    if (data) {
      setLoading(false)
      // Signup succeeded → a verification email was sent. Notify the user.
      toast.success(
        (data as any)?.message ||
          "Verification email sent! Please check your inbox to verify your account.",
        { autoClose: 3000 },
      )
      dispatch(logout())
      setTimeout(() => {
        navigate("/")
      }, 1200)
    }
  }, [data, error, isError])

  return (
    <>
      <Grid container justifyContent="center">
        <Grid
          item
          lg={7}
          className="d-none d-lg-block"
          display="flex"
          alignItems="center"
        >
          <Box className="box-wrapper">
            <Typography
              sx={{
                textAlign: "center",
                color: " #858585",
                fontFamily: "Montserrat",
                fontSize: "30px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "normal",
              }}
            >
              Welcome To
            </Typography>
            <Typography textAlign="center">
              <img src={mommylogo} width="300" height="auto" />
            </Typography>
            <Box
              className="Imgbox"
              display="flex"
              justifyContent="center"
              flexWrap="wrap"
              gap={2}
            >
              <Box>
                <img src={baby1} />
              </Box>
              <Box mt={5}>
                <img src={baby2} />
              </Box>

              <Box>
                <img src={baby3} />
              </Box>

              <Box mt={5}>
                <img src={baby4} />
              </Box>
            </Box>
          </Box>
        </Grid>

        <Grid item lg={5}>
          <Box className="Loginform">
            <Typography
              variant="h4"
              mt={5}
              fontFamily="Montserrat"
              fontSize={22}
              fontWeight="600"
              color="pink.main"
              textAlign="center"
            >
              Customer's Sign Up
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box>
                <FormControl sx={{ mt: 2 }} variant="outlined" fullWidth>
                  <InputLabel htmlFor="outlined-adornment-name">
                    Name
                  </InputLabel>

                  <Controller
                    name="name"
                    control={control}
                    render={({ field }: any) => (
                      <OutlinedInput
                        id="outlined-adornment-name"
                        {...field}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              <AiOutlineUser />
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Name"
                        size="medium"
                      />
                    )}
                  />
                  <p className="text-danger">{errors.name?.message}</p>
                </FormControl>

                <FormControl variant="outlined" fullWidth>
                  <InputLabel htmlFor="outlined-adornment-email">
                    Email
                  </InputLabel>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }: any) => (
                      <OutlinedInput
                        {...field}
                        type="email"
                        id="outlined-adornment-email"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              <AiOutlineMail />
                            </IconButton>
                          </InputAdornment>
                        }
                        label="email"
                      />
                    )}
                  />
                  <p className="text-danger">{errors.email?.message}</p>
                </FormControl>

                <FormControl variant="outlined" fullWidth>
                  <InputLabel
                    htmlFor="outlined-adornment-name"
                    className="bg-white rounded"
                  >
                    Phone Number
                  </InputLabel>
                  <Controller
                    name="contactNo"
                    control={control}
                    render={({ field }: any) => (
                      <OutlinedInput
                        {...field}
                        type="text"
                        inputMode="numeric"
                        id="outlined-adornment-name"
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                            "Delete",
                            "Home",
                            "End",
                          ]
                          if (
                            event.ctrlKey ||
                            event.metaKey ||
                            allowedKeys.includes(event.key)
                          ) {
                            return
                          }
                          const numericRegex = /^[0-9]$/
                          if (!numericRegex.test(event.key)) {
                            event.preventDefault()
                          }
                        }}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              <MdLocalPhone />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    )}
                  />
                  <p className="text-danger">{errors.contactNo?.message}</p>
                </FormControl>
                {/* <FormControl variant="outlined" fullWidth>
                  <InputLabel htmlFor="outlined-adornment-password">
                    Password
                  </InputLabel>
                  <Controller
                    name="password"
                    control={control}
                    render={({ field }: any) => (
                      <OutlinedInput
                        {...field}
                        id="outlined-adornment-password"
                        placeholder="Password"
                        type={showPassword ? "text" : "password"}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? <AiFillUnlock /> : <AiFillLock />}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="password"
                      />
                    )}
                  />
                  <p className="text-danger">{errors?.password?.message}</p>
                </FormControl> */}
                <FormControl variant="outlined" fullWidth>
                  <InputLabel htmlFor="outlined-adornment-password">
                    Password
                  </InputLabel>
                  <Controller
                    name="password"
                    control={control}
                    render={({ field }: any) => (
                      <OutlinedInput
                        {...field}
                        id="outlined-adornment-password"
                        placeholder="Password"
                        type={showPassword ? "text" : "password"}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <MdVisibility />
                              ) : (
                                <MdVisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="password"
                      />
                    )}
                  />
                  <p className="text-danger">{errors?.password?.message}</p>
                </FormControl>
              </Box>

              <Box mb={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={termsAccepted}
                      onChange={(e) => {
                        setTermsAccepted(e.target.checked);
                        if (e.target.checked) setShowTermsModal(true);
                      }}
                      sx={{ color: '#f07fa9', '&.Mui-checked': { color: '#f07fa9' } }}
                    />
                  }
                  label={
                    <Typography variant="body2">
                      I agree to the{' '}
                      <span
                        onClick={(e) => {
                          e.preventDefault();
                          setShowTermsModal(true);
                        }}
                        style={{ color: '#f07fa9', cursor: 'pointer', fontWeight: 'bold', textDecoration: 'underline' }}
                      >
                        Terms and Conditions
                      </span>
                    </Typography>
                  }
                />
              </Box>

              <Box>
                <Button
                  type="submit"
                  size="large"
                  variant="contained"
                  className="auth-btn mx-auto"
                  sx={{ display: "block", cursor: "pointer" }}
                  fullWidth
                >
                  {loading ? (
                    <Typography fontSize={1}>
                      <CircularProgress
                        style={{ color: "white", fontSize: 26 }}
                        size={26}
                      />
                    </Typography>
                  ) : (
                    "Sign Up"
                  )}
                </Button>
              </Box>
            </form>
            <Box mt={3}>
              <Typography
                sx={{
                  color: "#7B7B7B",
                  margin: "8px 0 0 13px",
                  textAlign: "center",
                }}
              >
                Already Have An Account?{" "}
                <Typography
                  component="span"
                  sx={{ color: "#181818", cursor: "pointer" }}
                  onClick={() => navigate("/")}
                >
                  Sign In
                </Typography>
              </Typography>
            </Box>
            <button
              onClick={() =>
                handleGoogleLogin()
                  .unwrap()
                  .then((r) => window.open(r.url, "_self"))
              }
              disabled={googleLoading}
              className="bg-transparent border-0 rounded-circle shadow-lg p-2 mx-auto mt-4"
            >
              <Box>
                <img src={googleLogo} height={35} />
              </Box>
            </button>
          </Box>
        </Grid>
      </Grid>

      {/* Terms and Conditions Modal */}
      <Dialog
        open={showTermsModal}
        onClose={() => setShowTermsModal(false)}
        maxWidth="md"
        fullWidth
        scroll="paper"
        sx={{
          '& .MuiDialog-paper': {
            maxHeight: '80vh'
          }
        }}
      >
        <DialogTitle sx={{
          backgroundColor: '#f5f5f5',
          borderBottom: '1px solid #e0e0e0',
          fontWeight: 'bold',
          color: '#333',
          textAlign: 'center'
        }}>
          {commonTerms?.title || "Terms and Conditions"}
        </DialogTitle>

        <DialogContent sx={{ mt: 2, maxHeight: '60vh', pb: 2 }}>
          <Box sx={{ mb: 4 }}>
            {commonTerms?.content?.map((section: any, sectionIndex: number) => (
              <Box key={sectionIndex} sx={{ mb: 3 }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 'bold',
                    color: '#333',
                    mb: 1,
                    borderBottom: '2px solid #f07fa9',
                    pb: 0.5
                  }}
                >
                  {section.section}
                </Typography>
                <Box sx={{ pl: 1 }}>
                  {section.items.map((item: string, itemIndex: number) => (
                    <Typography
                      key={itemIndex}
                      variant="body2"
                      sx={{
                        mb: 1.5,
                        lineHeight: 1.6,
                        textAlign: 'justify'
                      }}
                    >
                      {item}
                    </Typography>
                  ))}
                </Box>
              </Box>
            ))}
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 3, gap: 2, borderTop: '1px solid #e0e0e0' }}>
          <Button
            onClick={() => setShowTermsModal(false)}
            variant="outlined"
            sx={{
              borderColor: '#f07fa9',
              color: '#f07fa9',
              '&:hover': {
                borderColor: '#d06a94',
                backgroundColor: 'rgba(240, 127, 169, 0.04)'
              }
            }}
          >
            Close
          </Button>
          <Button
            onClick={() => {
              setTermsAccepted(true);
              setShowTermsModal(false);
            }}
            variant="contained"
            sx={{
              backgroundColor: '#f07fa9',
              '&:hover': {
                backgroundColor: '#d06a94'
              }
            }}
          >
            Accept
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Signup
